import { graphql, Link } from 'gatsby';
import React, { useState } from 'react';
import { Column, Container, Row } from '../../components/Grid';
import Image from '../../components/Image';
import Layout from '../../components/Layout';
import Section from '../../components/Section';

const AlumniGrantRecipients = ({ data }) => {
  const allRecipients = data.allAlumniGrantRecipientsYaml.nodes;
  const years = [...new Set(allRecipients.map((r) => r.year))].sort(
    (a, b) => b - a
  );

  const [selectedYear, setSelectedYear] = useState(null);
  const [dropdownOpen, setDropdownOpen] = useState(false);

  const filtered = selectedYear
    ? allRecipients.filter((r) => r.year === selectedYear)
    : allRecipients;

  return (
    <Layout title="Alumni Grant Recipients" className="grant-recipients">
      <div className="hero-container">
        <div className="hero-container__gradient bg-gradient-blue"></div>
        <div className="hero-container__titleImage">
          {/* Breadcrumbs */}
          <ul className="breadcrumbs">
            <li className="breadcrumb">
              <Link to="../../alumni-center/overview">Overview</Link>
            </li>
            <li className="breadcrumb active">Alumni Grant Recipients</li>
          </ul>
          <h1 className="page-title">Alumni Grant Recipients</h1>
          <Image filename="hero-alumni-grants.png" className="hero-image" />
          <Container className="hero-container__content">
            <h2 className="hero-container__title">
              Meet the Alumni Grant Recipients
            </h2>
            <p>
              Meet some incredible members of the 3M Young Scientist Challenge
              Alumni Network who have received Alumni Grant funding to continue
              their 3M Young Scientist Challenge innovations or begin a new
              journey to better the world with STEM!
            </p>
          </Container>
        </div>
      </div>

      {/* Funding Areas */}
      <Section>
        <Container>
          <h2 className="pt-2">
            The current Alumni Grant funding areas <br /> awarded include the
            following:
          </h2>
          <Row className="pt-2 funding-area-cards">
            <Column size={4}>
              <Image filename="alumni-grant-scientist-challenge.svg" />
              <h3>Continuation of 3M Young Scientist Challenge Project</h3>
              <p>
                This grant supports Alumni who are interested in continuing to
                progress or evolve the project they originally developed during
                the 3M Young Scientist Challenge.
              </p>
            </Column>
            <Column size={4}>
              <Image filename="alumni-grant-ideas.svg" />
              <h3>New Idea to Improve the World</h3>
              <p>
                This grant is available to Alumni who have developed projects
                that are different from their original 3M Young Scientist
                Challenge innovation.
              </p>
            </Column>
            <Column size={4}>
              <Image filename="alumni-grant-community.svg" />
              <h3>Science in Your Community</h3>
              <p>
                This grant can be used to support Alumni initiatives such as
                community enrichment opportunities, school events, or community
                activation projects.
              </p>
            </Column>
          </Row>
        </Container>
      </Section>

      {/* Year Filter + Cards */}
      <Section className="alumni-cards-section">
        <Container>
          {/* Year filter */}
          <div className="grant-year-filter">
            <div className="grant-year-filter__dropdown">
              <button
                className="grant-year-filter__toggle"
                onClick={() => setDropdownOpen((o) => !o)}
              >
                {selectedYear || 'All Years'} &#9662;
              </button>
              {dropdownOpen && (
                <ul className="grant-year-filter__menu">
                  <li
                    onClick={() => {
                      setSelectedYear(null);
                      setDropdownOpen(false);
                    }}
                    className={!selectedYear ? 'active' : ''}
                  >
                    All Years
                  </li>
                  {years.map((year) => (
                    <li
                      key={year}
                      onClick={() => {
                        setSelectedYear(year);
                        setDropdownOpen(false);
                      }}
                      className={selectedYear === year ? 'active' : ''}
                    >
                      {year}
                    </li>
                  ))}
                </ul>
              )}
            </div>
          </div>

          <Row>
            {filtered.map((recipient) => (
              <Column size={4} key={recipient.slug}>
                <div className="profile-card box-shadow hover imagezoom">
                  <div className="profile-card__image">
                    <Image filename={recipient.cardImage} />
                  </div>
                  <div className="profile-card__content">
                    <span>
                      {recipient.finalistYear} {recipient.finalistAward}
                    </span>
                    <br />
                    <span>{recipient.year} Alumni Grant Recipient</span>
                    <h3>
                      {recipient.firstName} {recipient.lastName}
                    </h3>
                    <p>
                      Meet {recipient.firstName}. {recipient.cardDescription}
                    </p>
                    <Link to={recipient.slug} className="text-20 text-bold">
                      Learn More {'>'}
                    </Link>
                  </div>
                </div>
              </Column>
            ))}
          </Row>
        </Container>
      </Section>
    </Layout>
  );
};

export const query = graphql`
  query AlumniGrantRecipientsQuery {
    allAlumniGrantRecipientsYaml(
      sort: { fields: [year, lastName], order: [DESC, ASC] }
    ) {
      nodes {
        firstName
        lastName
        slug
        year
        finalistYear
        finalistAward
        grantType
        cardImage
        cardDescription
      }
    }
  }
`;

export default AlumniGrantRecipients;
